import {
	Facebook,
	Instagram,
	LinkShare,
	Twitter,
	Whatsapp,
} from "../../icon/IconTheme";

export const social_icons = [
	{
		icon: <Facebook />,
		link: "#",
	},
	{
		icon: <Whatsapp />,
		link: "#",
	},
	{
		icon: <Instagram />,
		link: "#",
	},
	{
		icon: <Twitter />,
		link: "#",
	},
	{
		icon: <LinkShare />,
		link: "#",
	},
];
